var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_34);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #656fb2;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.25px;\r\n      }\r\n\r\n      .cls-5 {\r\n        filter: url(#Ellipse_33);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_33",
    x: -0.5,
    y: 3,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_34",
    "data-name": "Artboard \\u2013 34",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(-10586.5 -6605.43)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, 10586.5, 6605.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33-2",
    "data-name": "Ellipse 33",
    className: "cls-2",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(8.5 9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(10602.937 6623.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-check",
    "data-name": "Icon feather-user-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-3",
    d: "M8.746,12.623V11.54A2.165,2.165,0,0,0,6.58,9.375H2.79A2.165,2.165,0,0,0,.625,11.54v1.083",
    transform: "translate(-0.625 -2.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-3",
    d: "M7.143,4.04A2.165,2.165,0,1,1,4.978,1.875,2.165,2.165,0,0,1,7.143,4.04Z",
    transform: "translate(-0.918 -1.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-3",
    d: "M10.625,6.708,11.708,7.79l2.165-2.165",
    transform: "translate(-1.963 -2.377)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(10602.937 6623.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-plus",
    "data-name": "Icon feather-user-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-4",
    d: "M8.746,12.623V11.54A2.165,2.165,0,0,0,6.58,9.375H2.79A2.165,2.165,0,0,0,.625,11.54v1.083",
    transform: "translate(-0.625 -2.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-4",
    d: "M7.143,4.04A2.165,2.165,0,1,1,4.978,1.875,2.165,2.165,0,0,1,7.143,4.04Z",
    transform: "translate(-0.918 -1.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-4",
    d: "M12.5,5V8.248",
    transform: "translate(-2.214 -2.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-4",
    d: "M13.873,6.875H10.625",
    transform: "translate(-1.963 -2.544)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard34);
export default __webpack_public_path__ + "static/media/Artboard – 34.65eeb74a0c9eb04716045916c388dc48.svg";
export { ForwardRef as ReactComponent };